<div [formGroup]="form">
  <h1 class="title ">
    Bienvenue {{ form.get("firstname")?.value }} ! Continuons à Créer votre profil
  </h1>
  <h5 class="title-text-muted text-muted fs-16">
    Vos données restent confidentielles et seront utilisées uniquement lors de vos missions
    professionnelles.
  </h5>
  <div>
    <app-custom-dragdrop-image text1="" innerClass="rounded border border-1 p-4 me-2" [singleImage]="true" text2=""
      width="146" height="146" [smallInput]="true" text3="Ajouter une photo de profil" icon="/assets/icons/camera.svg"
      [forProfile]="true"
      (sendImage)="getImage($event)" [isDeletble]="true">
    </app-custom-dragdrop-image>

    <div class="row my-2 mt-px-16 align-items-end">
      <div class="col-3">
        <app-custom-drop-down [parentForm]="form" controlName="civility" class="prefixe-class" [label]="'Civilité'"
          [options]="civilityOptions" [required]="true" [simpleDropDown]="true"></app-custom-drop-down>
      </div>
      <div class="col">
        <app-custom-input [parentForm]="form" controlName="firstname" [label]="'Votre Nom'"
          [required]="true"></app-custom-input>
      </div>
      <div class="col">
        <app-custom-input [parentForm]="form" controlName="lastname" [label]="'Votre Prénom'"
          [required]="true"></app-custom-input>
      </div>
    </div>
    
    <div class="my-px-16" [formGroup]="form">
      <mat-label>Votre date de naissance
        <span class="required">*</span>
      </mat-label>
      <input class="form-control py-px-12" formControlName="birthDay" placeholder="Sélectionner" type="date"
        [defaultValue]="form.get('birthDay')?.value" [max]="maxDate" />
    </div>
    
    <app-custom-drop-down [loading]="loadingSecteur" [parentForm]="form" controlName="worktype" class="prefixe-class"
      [label]="'Votre domaine d’activité'" [optionsDisplay]="domaineOptions" [options]="domaineOptions"
      [required]="true" [simpleDropDown]="true" innerClass="mt-px-16"></app-custom-drop-down>

    <div class="text-muted">
      Si vous êtes médecin ou chirurgien, choisissez le domaine Médecins
    </div>
    <!-- <app-custom-input [parentForm]="form" controlName="fonction" [label]="'Votre fonction précise'"
                      innerClass="mt-px-10"
                      [required]="true"></app-custom-input> -->
    <div class="row my-4">
      <app-custom-drop-down [parentForm]="form" controlName="fonction" [label]="'Votre fonction précise'"
        [optionsDisplay]="fonctionOptions" [options]="fonctionOptions" [required]="true"
        [simpleDropDown]="true"></app-custom-drop-down>
    </div>

    <div class="mt-px-16">
      <mat-label>Téléphone <span class="required">*</span></mat-label>
      <ngx-intl-tel-input [cssClass]="'custom'" [preferredCountries]="[CountryISO.France]"
        [enableAutoCountrySelect]="false" [enablePlaceholder]="true" [searchCountryFlag]="true" [searchCountryField]="[
          SearchCountryField.Iso2,
          SearchCountryField.Name
        ]" [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.France" [maxLength]="phoneMaxLength"
        [(ngModel)]="phoneNumber"
       (ngModelChange)="onInputChange($event)"
        [phoneValidation]="true" [inputId]="'my-input-id'" formControlName="numtel"></ngx-intl-tel-input>
        
      <div *ngIf="form.get('numtel')?.touched && form.get('numtel')?.invalid" class="required">
        Veuillez saisir un numéro valide.
      </div>
      <app-custom-input [label]="'Numéro SIRET'" [type]="'number'" [parentForm]="form" innerClass="mt-px-16"
        controlName="numsiret" [placeholder]="'0'" [required]="false"
         (input)="onSiretInputChange($event)"
        [errorMessage]="'Numéro SIRET doit avoir 14 numéro'"></app-custom-input>
        <span>Le SIRET est composé de 14 chiffres</span>
      <div class="row mt-px-16">
        <div class="col-10">
          <app-custom-input [label]="'Numéro de sécurité sociale'" [type]="'number'" [parentForm]="form"
            controlName="numsocialsecurity"
             (input)="onSecurityInputChange($event)"
            [errorMessage]="'Numéro de sécurité sociale doit avoir 13 numéro'"
            [placeholder]="'0'"></app-custom-input>
            <span>Le numéro de sécurité sociale est composé de 13 chiffres</span>
        </div>
        <div class="col-2">
          <app-custom-input [label]="'Clé'" 
              (input)="onKeyInputChange($event)"
          [type]="'number'" [errorMessage]="'Numéro clé doit avoir 2 numéro'"
            [parentForm]="form" controlName="key" [placeholder]="'0'"></app-custom-input>
            <span>la clé est composé de 2 chiffres</span>
        </div>
      </div>
      <app-custom-checkbox [formGroup]="form" controlName="ishandicap" class="mt-px-16" [label]="'Êtes-vous porteur(euse) d’un
handicap ?'"></app-custom-checkbox>
      <app-custom-input *ngIf="form.get('ishandicap')?.value" label="Commentaire" innerClass="my-px-16"
        [required]="false" [parentForm]="form" controlName="handicapsituation" placeholder="Donnez nous plus d’informations sur votre handicap." type="textarea"></app-custom-input>
      <app-button color="primary" [disabled]="form.invalid" text="Suivant" (handleClick)="update(onSubmit)"
        class="mx-auto text-center" [innerClass]="'p-3 w-100'"></app-button>
      <h5 class="title-text-muted text-muted fs-16 mt-px-16">
        Vous pourrez toujours mettre à jour ces information ultérieurement
      </h5>
    </div>
  </div>
</div>